import {types} from './types';

const setGetGroupsAction = (payload) => {
    return {
      type: types.SET_GROUPS,
      payload,
    }
}

const setGetDailyListAction = (payload) => {
  return {
      type: types.SET_DAYLI,
      payload,
    }
}

const setGetShiftAction = (payload) => {
  return {
      type: types.SET_SHIFT,
      payload,
    }
}

const setGroupsViewAction = (payload) => {
  return {
      type: types.SET_GROUPS_VIEW,
      payload,
    }
}

const setGetGamerInformationAction = (payload) => {
  return {
    type: types.SET_COUNT_GAMER,
    payload
  }
}

const setGetOperatorDetalizationAction = (payload) => {
  return {
    type: types.SET_OPERATOR_DETALIZATION,
    payload
  }
}

const setGetBetAction = (payload) => {
  return {
    type: types.SET_BET,
    payload
  }
}

export {
  setGetGroupsAction,
  setGetDailyListAction,
  setGetShiftAction,
  setGroupsViewAction,
  setGetGamerInformationAction,
  setGetOperatorDetalizationAction,
  setGetBetAction
}